import React from "react";
import { companyInfo } from "@/data/mock";

const HeroSection = () => {
  const ptName = "PT SATHRUSI KOMODITI INDONESIA";
  const bgSrc = companyInfo.heroWatermark ?? companyInfo.logo; // pake gambar SHAKTI (watermark) kalau ada

  return (
    <section
      id="hero"
      className="relative min-h-screen overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, rgba(250,250,250,1) 0%, rgba(255,245,247,1) 55%, rgba(255,255,255,1) 100%)",
      }}
    >
      {/* Tengah: Background/Watermark SHAKTI */}
      <div className="min-h-screen w-full flex flex-col items-center justify-center px-4 gap-6">
        <img
          src={encodeURI(companyInfo.heroBackground)}
          alt="SHAKTI"
          className="select-none pointer-events-none w-[320px] mt-5 sm:w-[420px] md:w-[560px] lg:w-[600px] h-auto opacity-90"
        />

        {/* Card PT di bawah gambar */}
        <div className="w-full max-w-[520px]">
          <div className="rounded-[26px] bg-white/90 backdrop-blur-md border border-[#a00e21]/15 px-6 md:px-7 py-5 md:py-6 shadow-[0_22px_70px_rgba(0,0,0,0.08)]">
            <div className="flex items-center gap-4">
              <div className="shrink-0">
                <img
                  src={encodeURI(companyInfo.logo)}
                  alt="Logo"
                  className="w-16 h-16 md:w-20 md:h-20 object-contain rounded-[18px]"
                />
              </div>

              <div className="min-w-0">
                <h2 className="text-[#a00e21] text-base md:text-xl font-black leading-snug">
                  {ptName}
                </h2>

             <p className="mt-1 text-gray-700 text-xs md:text-sm font-semibold tracking-wide">
                  {companyInfo.tagline}
                </p>

                <div className="mt-3 h-1 w-24 rounded-full bg-[#edf011]" />
                {/* kalau mau tetap ada tagline kecil, buka komentar ini */}
                {/* <p className="mt-1 text-gray-700 text-xs md:text-sm font-semibold tracking-wide">
                  {companyInfo.tagline}
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
